export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14704.e0234210.jpg";